import { Injectable, HostListener, Inject } from "@angular/core";
import { BehaviorSubject, Observable, Subscriber } from "rxjs";
import { WINDOW } from "./windows.service";
// Menu
export interface Menu {
  path?: string;
  title?: string;
  icon?: string;
  type?: string;
  badgeType?: string;
  badgeValue?: string;
  active?: boolean;
  bookmark?: boolean;
  children?: Menu[];
}

@Injectable({
  providedIn: "root",
})
export class NavService {
  public screenWidth: any;
  public collapseSidebar: boolean = false;

  constructor(@Inject(WINDOW) private window) {
    this.onResize();
    if (this.screenWidth < 991) {
      this.collapseSidebar = true;
    }
  }

  // Windows width
  @HostListener("window:resize", ["$event"])
  onResize(event?) {
    this.screenWidth = window.innerWidth;
  }

  MENUITEMS: Menu[] = [
    {
      path: "/adminhkbkcms/dashboard/default",
      title: "Dashboard",
      icon: "home",
      type: "link",
      badgeType: "primary",
      active: false,
    },
    {
      title: "Media",
      path: "/adminhkbkcms/media",
      icon: "camera",
      type: "link",
      active: false,
    },
    /* {
			title: 'Other Files Path', path: '/adminhkbkcms/filespath', icon: 'file', type: 'link', active: false
		}, */
    /* {
			title: 'Our Institutions', icon: 'box', type: 'sub', active: false, children: [
				// { path: '/adminhkbkcms/engineeringpage/', title: 'Engineering', type: 'link' },
				{
					title: 'Institutions Information', type: 'sub', children: [
						{ path: '/adminhkbkcms/institutions/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/institutions/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Institutions Details', type: 'sub', children: [
						{ path: '/adminhkbkcms/institutions-info/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/institutions-info/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Institutions Slider', type: 'sub', children: [
						{ path: '/adminhkbkcms/institutionsslider/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/institutionsslider/create-page', title: 'Create Page', type: 'link' },
					]
				},
			]
		}, */
    {
      title: "Master",
      icon: "align-left",
      type: "sub",
      active: false,
      children: [
        // { path: '/adminhkbkcms/testimonials/', title: 'Testimonials', type: 'link' },
        {
          path: "/adminhkbkcms/homepage-overview",
          title: "Vision Mission",
          type: "link",
        },
        {
          title: "Pages",
          icon: "clipboard",
          type: "sub",
          active: false,
          children: [
            {
              path: "/adminhkbkcms/pages/list-page",
              title: "List Page",
              type: "link",
            },
            {
              path: "/adminhkbkcms/pages/create-page",
              title: "Create Page",
              type: "link",
            },
          ],
        },
        // {
        //   title: "Sections",
        //   icon: "clipboard",
        //   type: "sub",
        //   active: false,
        //   children: [
        //     {
        //       path: "/adminhkbkcms/sections/list-page",
        //       title: "List Page",
        //       type: "link",
        //     },
        //     {
        //       path: "/adminhkbkcms/sections/create-page",
        //       title: "Create Page",
        //       type: "link",
        //     },
        //   ],
        // },
        {
          title: "Testimonials",
          icon: "clipboard",
          type: "sub",
          active: false,
          children: [
            {
              path: "/adminhkbkcms/testimonials/list-page",
              title: "List Page",
              type: "link",
            },
            {
              path: "/adminhkbkcms/testimonials/create-page",
              title: "Create Page",
              type: "link",
            },
          ],
        },

        /* {
          title: "Governance",
          type: "sub",
          children: [
            {
              path: "/adminhkbkcms/leadership/list-page",
              title: "List Page",
              type: "link",
            },
            {
              path: "/adminhkbkcms/leadership/create-page",
              title: "Create Page",
              type: "link",
            },
          ],
        }, */
        /* {
          title: "Naac heading",
          type: "sub",
          children: [
            {
              path: "/adminhkbkcms/naac-heading/list-page",
              title: "List",
              type: "link",
            },
            {
              path: "/adminhkbkcms/naac-heading/create-page",
              title: "Create",
              type: "link",
            },
          ],
        },
        {
          title: "Naac Sub heading",
          type: "sub",
          children: [
            {
              path: "/adminhkbkcms/naac-sub-heading/list-page",
              title: "List",
              type: "link",
            },
            {
              path: "/adminhkbkcms/naac-sub-heading/create-page",
              title: "Create",
              type: "link",
            },
          ],
        }, */
        {
					title: 'Blogs', icon: 'clipboard', type: 'sub', active: false, children: [
						{ path: '/adminhkbkcms/blogs/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/blogs/create-page', title: 'Create Page', type: 'link' },
					]
				},
        /* {
          title: "News",
          icon: "clipboard",
          type: "sub",
          active: false,
          children: [
            {
              path: "/adminhkbkcms/news/list-page",
              title: "List Page",
              type: "link",
            },
            {
              path: "/adminhkbkcms/news/create-page",
              title: "Create Page",
              type: "link",
            },
          ],
        }, */
        {
					title: 'News Year', icon: 'clipboard', type: 'sub', active: false, children: [
						{ path: '/adminhkbkcms/news-year/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/news-year/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'News Categories', icon: 'clipboard', type: 'sub', active: false, children: [
						{ path: '/adminhkbkcms/news-categories/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/news-categories/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'News', icon: 'clipboard', type: 'sub', active: false, children: [
						{ path: '/adminhkbkcms/news/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/news/create-page', title: 'Create Page', type: 'link' },
					]
				},
        /* {
          title: "Facilities Heading",
          icon: "clipboard",
          type: "sub",
          active: false,
          children: [
            {
              path: "/adminhkbkcms/hkbkfacilities-heading/list-page",
              title: "List Page",
              type: "link",
            },
            {
              path: "/adminhkbkcms/hkbkfacilities-heading/create-page",
              title: "Create Page",
              type: "link",
            },
          ],
        },
        {
          title: "Facilities",
          icon: "clipboard",
          type: "sub",
          active: false,
          children: [
            {
              path: "/adminhkbkcms/hkbkfacilities/list-page",
              title: "List Page",
              type: "link",
            },
            {
              path: "/adminhkbkcms/hkbkfacilities/create-page",
              title: "Create Page",
              type: "link",
            },
          ],
        }, */
        /* {
          path: "/adminhkbkcms/campus/create-page/",
          title: "Facilities Overview",
          type: "link",
        },
        {
          title: "Gallery Heading",
          icon: "clipboard",
          type: "sub",
          active: false,
          children: [
            {
              path: "/adminhkbkcms/gallery-heading/list-page",
              title: "List Page",
              type: "link",
            },
            {
              path: "/adminhkbkcms/gallery-heading/create-page",
              title: "Create Page",
              type: "link",
            },
          ],
        }, */
        {
          title: "Gallery",
          icon: "clipboard",
          type: "sub",
          active: false,
          children: [
            {
              path: "/adminhkbkcms/gallery/list-page",
              title: "List Page",
              type: "link",
            },
            {
              path: "/adminhkbkcms/gallery/create-page",
              title: "Create Page",
              type: "link",
            },
          ],
        },
        {
          title: "Yoga",
          icon: "clipboard",
          type: "sub",
          active: false,
          children: [
            {
              path: "/adminhkbkcms/yoga/list-page",
              title: "List Page",
              type: "link",
            },
            {
              path: "/adminhkbkcms/yoga/create-page",
              title: "Create Page",
              type: "link",
            },
          ],
        },
        /* {
          title: "Campus News Events",
          icon: "box",
          type: "sub",
          active: false,
          children: [
            {
              path: "/adminhkbkcms/campus-news-events/list-campus-news-events",
              title: "List",
              type: "link",
            },
            {
              path: "/adminhkbkcms/campus-news-events/create-campus-news-events",
              title: "Create",
              type: "link",
            },
          ],
        }, */
        /* {
          title: "Faculty Department",
          icon: "box",
          type: "sub",
          active: false,
          children: [
            {
              path: "/adminhkbkcms/faculty-department/list-page",
              title: "List Page",
              type: "link",
            },
            {
              path: "/adminhkbkcms/faculty-department/create-page",
              title: "Create Page",
              type: "link",
            },
          ],
        }, */
        {
          title: "Mentors",
          icon: "box",
          type: "sub",
          active: false,
          children: [
            {
              path: "/adminhkbkcms/faculty/list-page",
              title: "List Page",
              type: "link",
            },
            {
              path: "/adminhkbkcms/faculty/create-page",
              title: "Create Page",
              type: "link",
            },
          ],
        },
        /* {
          title: "Objective",
          icon: "box",
          type: "sub",
          active: false,
          children: [
            {
              path: "/adminhkbkcms/objective/list-page",
              title: "List Page",
              type: "link",
            },
            {
              path: "/adminhkbkcms/objective/create-page",
              title: "Create Page",
              type: "link",
            },
          ],
        }, */
        // {
        //   title: "Messages",
        //   icon: "box",
        //   type: "sub",
        //   active: false,
        //   children: [
        //     {
        //       path: "/adminhkbkcms/messages/list-page",
        //       title: "List Page",
        //       type: "link",
        //     },
        //     {
        //       path: "/adminhkbkcms/messages/create-page",
        //       title: "Create Page",
        //       type: "link",
        //     },
        //   ],
        // },
        /* {
          title: "Achievements",
          icon: "box",
          type: "sub",
          active: false,
          children: [
            {
              path: "/adminhkbkcms/achievements/list-page",
              title: "List Page",
              type: "link",
            },
            {
              path: "/adminhkbkcms/achievements/create-page",
              title: "Create Page",
              type: "link",
            },
          ],
        }, */
        /* {
          path: "/adminhkbkcms/library",
          icon: "box",
          title: "Library",
          type: "link",
        }, */
        /* {
          path: "/adminhkbkcms/insurance",
          icon: "box",
          title: "Insurance",
          type: "link",
        }, */
        /* {
          title: "NAAC",
          type: "sub",
          children: [
            {
              path: "/adminhkbkcms/iqacsubheading/list-page",
              title: "List Page",
              type: "link",
            },
            {
              path: "/adminhkbkcms/iqacsubheading/create-page",
              title: "Create Page",
              type: "link",
            },
          ],
        }, */
        /* {
          title: "Upcomingevents",
          type: "sub",
          children: [
            {
              path: "/adminhkbkcms/upcomingevents/list-page",
              title: "List Page",
              type: "link",
            },
            {
              path: "/adminhkbkcms/upcomingevents/create-page",
              title: "Create Page",
              type: "link",
            },
          ],
        }, */
        /*  {
          path: "/adminhkbkcms/international-students/",
          title: "International Students",
          type: "link",
        }, */
        {
          title: "Placements Overview",
          type: "sub",
          children: [
            {
              path: "/adminhkbkcms/placements/list-page",
              title: "List Page",
              type: "link",
            },
            {
              path: "/adminhkbkcms/placements/create-page",
              title: "Create Page",
              type: "link",
            },
          ],
        },
        /* {
          path: "/adminhkbkcms/alumni-feedback/list-page",
          icon: "box",
          title: "Alumni Feedback",
          type: "link",
        },
        {
          path: "/adminhkbkcms/course-feedback/list-page",
          icon: "box",
          title: "Course Feedback",
          type: "link",
        },
        {
          path: "/adminhkbkcms/infrastructure-feedback/list-page",
          icon: "box",
          title: "Infrastructure Feedback",
          type: "link",
        },
        {
          path: "/adminhkbkcms/parents-feedback/list-page",
          icon: "box",
          title: "Parents Feecback",
          type: "link",
        }, */
        {
          title: "Home Sliders",
          type: "sub",
          children: [
            {
              path: "/adminhkbkcms/recruiter/list-recruiter",
              title: "List",
              type: "link",
            },
            {
              path: "/adminhkbkcms/recruiter/create-recruiter",
              title: "Create",
              type: "link",
            },
          ],
        },
        /* 
				{
					title: 'Student Stories', type: 'sub', children: [
						{ path: '/adminhkbkcms/studentstories/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/studentstories/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'News Year', icon: 'clipboard', type: 'sub', active: false, children: [
						{ path: '/adminhkbkcms/news-year/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/news-year/create-page', title: 'Create Page', type: 'link' },
					]
				},
				 */
      ],
    },
    /* {
      title: "Clubs",
      icon: "align-left",
      type: "sub",
      active: false,
      children: [
        {
          title: "Club Type",
          type: "sub",
          children: [
            {
              path: "/adminhkbkcms/club-type/list-page",
              title: "List Page",
              type: "link",
            },
            {
              path: "/adminhkbkcms/club-type/create-page",
              title: "Create Page",
              type: "link",
            },
          ],
        },
        {
          title: "Club Details",
          type: "sub",
          children: [
            {
              path: "/adminhkbkcms/facility/list-page",
              title: "List Page",
              type: "link",
            },
            {
              path: "/adminhkbkcms/facility/create-page",
              title: "Create Page",
              type: "link",
            },
          ],
        },
      ],
    }, */
    {
      title: "Courses",
      icon: "box",
      type: "sub",
      active: false,
      children: [
        {
          title: "Add Course",
          icon: "users",
          type: "sub",
          active: false,
          children: [
            {
              path: "/adminhkbkcms/course/list-page",
              title: "Courses List",
              type: "link",
            },
            {
              path: "/adminhkbkcms/course/create-page",
              title: "Create Course",
              type: "link",
            },
          ],
        },
        /* {
					title: 'Fees and Scholarship', type: 'sub', children: [
						{ path: '/adminhkbkcms/fees/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/fees/create-page', title: 'Create Page', type: 'link' },
					]
				}, */
        /* {
          title: "Curriculum",
          type: "sub",
          children: [
            {
              path: "/adminhkbkcms/curriculum/list-page",
              title: "List Page",
              type: "link",
            },
            {
              path: "/adminhkbkcms/curriculum/create-page",
              title: "Create Page",
              type: "link",
            },
          ],
        },*/
        {
          title: "Moredetails",
          type: "sub",
          children: [
            {
              path: "/adminhkbkcms/moredetails/list-page",
              title: "List Page",
              type: "link",
            },
            {
              path: "/adminhkbkcms/moredetails/create-page",
              title: "Create Page",
              type: "link",
            },
          ],
        }, 
        /* {
					title: 'Eligibility', type: 'sub', children: [
						{ path: '/adminhkbkcms/eligibility/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/eligibility/create-page', title: 'Create Page', type: 'link' },
					]
				},
				
				{
					title: 'Recruiters', type: 'sub', children: [
						{ path: '/adminhkbkcms/recruiters/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/recruiters/create-page', title: 'Create Page', type: 'link' },
					]
				}, */
      ],
    },
    /* {
			title: 'Home', icon: 'box', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/homecontents/', title: 'Home Contents', type: 'link' },
				{ path: '/adminhkbkcms/aboutbrowseby/', title: 'About Browse By', type: 'link' },
				{
					title: 'Home Rank Section', type: 'sub', children: [
						{ path: '/adminhkbkcms/homeranksection/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/homeranksection/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Home Slider', type: 'sub', children: [
						{ path: '/adminhkbkcms/homeslider/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/homeslider/create-page', title: 'Create Page', type: 'link' },
					]
				},
			]
		},
		{
			title: 'Campus', icon: 'box', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/campus/create-page/', title: 'Campus Overview', type: 'link' },
				{
					title: 'Facilities Overview', type: 'sub', children: [
						{ path: '/adminhkbkcms/facilitiesoverview/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/facilitiesoverview/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Facility', type: 'sub', children: [
						{ path: '/adminhkbkcms/facility/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/facility/create-page', title: 'Create Page', type: 'link' },
					]
				},
			]
		}, */
    /* {
			title: 'About Us', icon: 'box', type: 'sub', active: false, children: [
				{
					title: 'Overview', icon: 'users', type: 'sub', active: false, children: [
						{ path: '/adminhkbkcms/aboutusoverview', title: 'Edit Overview', type: 'link' },
					]
				},
				{
					title: 'Rankings Recognitions', type: 'sub', children: [
						{ path: '/adminhkbkcms/rankings/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/rankings/create-page', title: 'Create Page', type: 'link' },
					]
				},
				
				{
					title: 'IQAC Heading', type: 'sub', children: [
						{ path: '/adminhkbkcms/iqacheading/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/iqacheading/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'IQAC Sub Heading', type: 'sub', children: [
						{ path: '/adminhkbkcms/iqacsubheading/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/iqacsubheading/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'IQAC Content', type: 'sub', children: [
						{ path: '/adminhkbkcms/iqaccontent/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/iqaccontent/create-page', title: 'Create Page', type: 'link' },
					]
				},
			]
		}, */
    /* {
			title: 'Academics', icon: 'box', type: 'sub', active: false, children: [
				{
					title: 'Academics Information', type: 'sub', children: [
						{ path: '/adminhkbkcms/academics/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/academics/create-page', title: 'Create Page', type: 'link' },
					]
				},
			]
		}, */
    /* {
			title: 'Admissions', icon: 'box', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/how-to-apply/', title: 'How To Apply', type: 'link' },
				{ path: '/adminhkbkcms/indian-students/', title: 'Indian Students', type: 'link' },
				{ path: '/adminhkbkcms/international-students/', title: 'International Students', type: 'link' },
			]
		},
		{
			title: 'Research & Innovation', icon: 'box', type: 'sub', active: false, children: [
				{
					title: 'Institute Industry Connect', type: 'sub', children: [
						{ path: '/adminhkbkcms/iic/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/iic/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Learning Resources', type: 'sub', children: [
						{ path: '/adminhkbkcms/learning-resources/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/learning-resources/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Learning Resources Uploads', type: 'sub', children: [
						{ path: '/adminhkbkcms/learning-resources-uploads/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/learning-resources-uploads/create-page', title: 'Create Page', type: 'link' },
					]
				},
			]
		},
		{
			title: 'Faculty', icon: 'box', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/faculty/list-page', title: 'List Page', type: 'link' },
				{ path: '/adminhkbkcms/faculty/create-page', title: 'Create Page', type: 'link' },
			]
		}, */
    /* {
			title: 'Faculty', icon: 'box', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/faculty/list-page', title: 'List Page', type: 'link' },
				{ path: '/adminhkbkcms/faculty/create-page', title: 'Create Page', type: 'link' },
			]
		}, */
    /* {
			title: 'Placements', icon: 'box', type: 'sub', active: false, children: [
				// {
					// title: 'Placements Overview', type: 'sub', children: [
						// { path: '/adminhkbkcms/placements-overview/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/placements-overview/create-page', title: 'Placements Overview', type: 'link' },
					// ]
				// },
				{
					title: 'Placements Otherinfo', type: 'sub', children: [
						{ path: '/adminhkbkcms/placements-otherinfo/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/placements-otherinfo/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Students Placed', type: 'sub', children: [
						{ path: '/adminhkbkcms/students-placed/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/students-placed/create-page', title: 'Create Page', type: 'link' },
					]
				},
			]
		}, */
    /*{
			title: 'Sales', icon: 'dollar-sign', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/sales/orders', title: 'Orders', type: 'link' },
				{ path: '/adminhkbkcms/sales/transactions', title: 'Transactions', type: 'link' },
			]
		},
		{
			title: 'Coupons', icon: 'tag', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/coupons/list-coupons', title: 'List Coupons', type: 'link' },
				{ path: '/adminhkbkcms/coupons/create-coupons', title: 'Create Coupons', type: 'link' },
			]
		},*/

    /* {
			title: 'Courses', icon: 'clipboard', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/course/list-page', title: 'List Page', type: 'link' },
				{ path: '/adminhkbkcms/course/create-page', title: 'Create Page', type: 'link' },
			]
		}, */

    /*{
			title: 'Menus', icon: 'align-left', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/menus/list-menu', title: 'Menu Lists', type: 'link' },
				{ path: '/adminhkbkcms/menus/create-menu', title: 'Create Menu', type: 'link' },
			]
		}, */
    {
      title: "Users",
      icon: "user-plus",
      type: "sub",
      active: false,
      children: [
        {
          path: "/adminhkbkcms/users/list-user",
          title: "User List",
          type: "link",
        },
        {
          path: "/adminhkbkcms/users/create-user",
          title: "Create User",
          type: "link",
        },
      ],
    },
    /* {
			title: 'Vendors', icon: 'users', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/vendors/list-vendors', title: 'Vendor List', type: 'link' },
				{ path: '/adminhkbkcms/vendors/create-vendors', title: 'Create Vendor', type: 'link' },
			]
		}, */
    /*{
			title: 'Localization', icon: 'chrome', type: 'sub', children: [
				{ path: '/adminhkbkcms/localization/translations', title: 'Translations', type: 'link' },
				{ path: '/adminhkbkcms/localization/currency-rates', title: 'Currency Rates', type: 'link' },
				{ path: '/adminhkbkcms/localization/taxes', title: 'Taxes', type: 'link' },
			]
		},*/
    /* {
			title: 'Reports', path: '/adminhkbkcms/reports', icon: 'bar-chart', type: 'link', active: false
		},
		{
			title: 'Settings', icon: 'settings', type: 'sub', children: [
				{ path: '/adminhkbkcms/settings/profile', title: 'Profile', type: 'link' },
			]
		},
		{
			title: 'Invoice', path: '/adminhkbkcms/invoice', icon: 'archive', type: 'link', active: false
		},
		{
			title: 'Login',path: '/adminhkbkcms/auth/login', icon: 'log-in', type: 'link', active: false
		} */
  ];
  // Array
  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
}
